/**
 * The // ensures links missing the http(s) prefix are treated as full links rather than a relative link.
 * @param value
 */
export function parseUrl(value: string) {
  return value.startsWith('http') ? value : `http://${value}`;
}
